import { Link, NavLink, Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { NAV, FOOTER } from "@/constants/testIds";

const NavBar = () => (
  <header className="border-b border-[hsl(var(--border-soft))]/60 backdrop-blur-sm bg-[hsl(var(--bg))]/70 sticky top-0 z-30">
    <div className="container-mp flex items-center justify-between py-4">
      <Link
        to="/"
        data-testid={NAV.brand}
        className="flex items-baseline gap-2 group"
      >
        <span className="font-display text-xl tracking-[0.18em] text-gold-bright group-hover:text-gold transition-colors">
          MON&nbsp;PRÉCIEUX
        </span>
        <span className="text-[10px] tracking-[0.3em] uppercase text-[hsl(var(--text-dim))]">
          ✦
        </span>
      </Link>
      <nav className="flex items-center gap-1 md:gap-3">
        <NavLink
          to="/contact"
          data-testid={NAV.contact}
          className={({ isActive }) =>
            `px-3 py-2 text-sm rounded-full transition-colors ${
              isActive
                ? "text-gold-bright"
                : "text-[hsl(var(--text-muted))] hover:text-gold-bright"
            }`
          }
        >
          Contact
        </NavLink>
        <Link to="/vendre" data-testid={NAV.startCta} className="btn-gold text-sm py-2 px-4">
          Démarrer mon devis
        </Link>
      </nav>
    </div>
    <div className="gold-divider" />
  </header>
);

const FooterLink = ({ to, testId, children }) => (
  <Link
    to={to}
    data-testid={testId}
    className="text-sm text-[hsl(var(--text-muted))] hover:text-gold-bright transition-colors"
  >
    {children}
  </Link>
);

const Footer = () => (
  <footer className="mt-24 border-t border-[hsl(var(--border-soft))]/60 bg-[hsl(var(--bg-elev))]/60">
    <div className="container-mp py-12 grid gap-10 md:grid-cols-3">
      <div>
        <div className="font-display text-lg tracking-[0.18em] text-gold-bright mb-3">
          MON&nbsp;PRÉCIEUX
        </div>
        <p className="text-sm text-[hsl(var(--text-muted))] max-w-xs leading-relaxed">
          Estimez en moins d’une minute la valeur de reprise de votre téléphone,
          tablette ou montre connectée. Finalisation sécurisée sur CompaRecycle.
        </p>
      </div>
      <div>
        <div className="text-xs uppercase tracking-[0.2em] text-[hsl(var(--text-dim))] mb-3">
          Informations
        </div>
        <div className="flex flex-col gap-2">
          <FooterLink to="/contact" testId={FOOTER.legal}>Nous contacter</FooterLink>
          <FooterLink to="/mentions-legales" testId={FOOTER.legal}>Mentions légales</FooterLink>
          <FooterLink to="/politique-confidentialite" testId={FOOTER.privacy}>Politique de confidentialité</FooterLink>
          <FooterLink to="/cookies" testId={FOOTER.cookies}>Cookies</FooterLink>
          <FooterLink to="/cgu" testId={FOOTER.cgu}>CGU</FooterLink>
          <FooterLink to="/faq" testId={FOOTER.faq}>FAQ</FooterLink>
        </div>
      </div>
      <div>
        <div className="text-xs uppercase tracking-[0.2em] text-[hsl(var(--text-dim))] mb-3">
          Partenaire
        </div>
        <p className="text-sm text-[hsl(var(--text-muted))] leading-relaxed">
          Toutes les transactions de reprise sont assurées par CompaRecycle. Mon
          Précieux est un comparateur indépendant — nous ne rachetons aucun
          appareil directement.
        </p>
      </div>
    </div>
    <div className="gold-divider" />
    <div className="container-mp py-6 flex items-center justify-between text-xs text-[hsl(var(--text-dim))]">
      <span>© {new Date().getFullYear()} Mon Précieux. Tous droits réservés.</span>
      <span className="font-serif italic">« Un seul site pour les guider tous. »</span>
    </div>
  </footer>
);

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

export default function Layout() {
  return (
    <div className="App noise-overlay relative">
      <ScrollToTop />
      <NavBar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
